import { QueryKey } from "react-query";

export const createAppointmentWebSetupKey = (): QueryKey => [
  "useAppointmentWebSetupKey",
];
